module.exports = __webpack_public_path__ + "static/img/software_icon3.2298a14f.png";